export default "__VITE_ASSET__CyqNYsf2__"